// Token store. Reuses the main BPM JWT: either logged in via the DPDP login form
// (which posts to the main auth endpoint) or SSO deep-link (?token=... from the
// main portal). Same token the main app / mobile app already hold.
//
// Access tokens are short-lived (15m upstream), so the refresh token issued at
// login is kept alongside and api.js trades it for a fresh access token. A token
// arriving by deep-link or paste has no refresh partner — that session simply
// ends when the access token expires.
const KEY = "dpdp_token";
const RKEY = "dpdp_refresh";

export function captureSsoToken() {
  const p = new URLSearchParams(window.location.search);
  const t = p.get("token");
  if (t) {
    localStorage.setItem(KEY, t);
    p.delete("token");
    const url = window.location.pathname + (p.toString() ? `?${p}` : "");
    window.history.replaceState({}, "", url);
  }
}

export const getToken = () => localStorage.getItem(KEY) || "";
export const setToken = (t) => localStorage.setItem(KEY, t);
export const getRefreshToken = () => localStorage.getItem(RKEY) || "";

export function setTokens(access, refresh) {
  if (access) localStorage.setItem(KEY, access);
  if (refresh) localStorage.setItem(RKEY, refresh);
}

export const clearToken = () => {
  localStorage.removeItem(KEY);
  localStorage.removeItem(RKEY);
};

export const isAuthed = () => !!getToken();

// Expiry (ms epoch) from the JWT's own `exp` claim; 0 when absent/unparseable.
// The payload is base64url, so restore the standard alphabet and padding first.
export function tokenExpiry(t) {
  try {
    const part = (t || "").split(".")[1];
    if (!part) return 0;
    const b64 = part.replace(/-/g, "+").replace(/_/g, "/");
    const padded = b64 + "=".repeat((4 - (b64.length % 4)) % 4);
    const { exp } = JSON.parse(atob(padded));
    return exp ? exp * 1000 : 0;
  } catch {
    return 0;
  }
}

// ── Phase 3: URL scope. /admin = Vxaro platform console, /t/<slug> = tenant app.
// The router basename is derived from this, so existing absolute links keep working.
const _path = window.location.pathname;
const _m = _path.match(/^\/t\/([a-z0-9-]+)/);
export const TENANT_SLUG = _m ? _m[1] : null;
export const IS_ADMIN = /^\/admin(\/|$)/.test(_path);
export const BASE = IS_ADMIN ? "/admin" : TENANT_SLUG ? `/t/${TENANT_SLUG}` : "";

export function tokenClaims(t) {
  try {
    const b64 = (t || "").split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(atob(b64 + "=".repeat((4 - (b64.length % 4)) % 4)));
  } catch { return {}; }
}

// A tenant token only opens its own tenant. Legacy BPM tokens (no tenant claim) open 'default'.
export function tenantTokenOk() {
  const c = tokenClaims(getToken());
  if (!getToken() || c.scope === "platform") return false;
  return c.tenant ? c.tenant === TENANT_SLUG : TENANT_SLUG === "default";
}

const PKEY = "dpdp_platform_token";
export const getPlatformToken = () => localStorage.getItem(PKEY) || "";
export const setPlatformToken = (t) => localStorage.setItem(PKEY, t);
export const clearPlatformToken = () => localStorage.removeItem(PKEY);
export const isPlatformAuthed = () => tokenClaims(getPlatformToken()).scope === "platform";
